<template>
    <VJoyIcon :size="size" :name="familyIcon" :color="color" data-testid="family-icon" />
</template>

<script setup lang="ts">
    import {computed, toRefs} from 'vue';
    import type {TJoyIconsColors} from '@maltjoy/core-vue';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import {useFamilyIcon} from './useFamilyIcon';

    type Props = {
        size: 'xsmall' | 'small';
        family: string;
        color?: TJoyIconsColors;
    };
    const props = defineProps<Props>();
    const {family} = toRefs(props);

    const {familyIconOf} = useFamilyIcon();

    const familyIcon = computed(() => familyIconOf(family.value));
</script>
